import React from 'react'
import { graphql } from 'gatsby'
import { useIntl } from 'gatsby-plugin-intl'

import Layout from 'components/layout'
import MetaTags from 'components/MetaTags'
import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import RoomPreview from 'components/RoomPreview'

import Heading from 'components/Heading'
import GridRow from 'components/grid/GridRow'
import GridItem from 'components/grid/GridItem'

import apartmentsContent from 'content/apartmentsContent.json'

const Suites = ({ data }) => {
  const intl = useIntl()
  const categories = apartmentsContent[intl.locale] || []

  const {
    headerImage: {
      childImageSharp: { fluid },
    },
  } = data

  return (
    <Layout>
      <MetaTags
        title={`${intl.formatMessage({ id: 'apartment' })} | Hotel Griffintown`}
      />
      <Header
        eyebrow={intl.formatMessage({ id: 'suites.eyebrow' })}
        heading={intl.formatMessage({ id: 'suites.heading' })}
        fluid={fluid}
      />
      {categories.map((cat) => (
        <Section key={cat.uid} id={cat.uid}>
          <Wrapper size='narrow'>
            <SectionBlock>
              <GridRow>
                <GridItem xs='1-1' lg='3-4'>
                  <Heading
                    size={2}
                    variant='sans'
                    css={`
                      margin-bottom: 0.5em;
                    `}
                  >
                    {cat.title}
                  </Heading>

                  {cat.description ? <p>{cat.description}</p> : null}
                </GridItem>
              </GridRow>
            </SectionBlock>
          </Wrapper>

          {cat.apartments.map((apt, i) => (
            <Section key={apt.slug} flushTop={i % 2 !== 0}>
              <Wrapper>
                <RoomPreview
                  name={apt.title}
                  description={apt.shortDescription}
                  beds={apt.beds}
                  size={apt.size}
                  to={`/apartments/${apt.slug}`}
                  imageUrl={apt.imageUrl}
                  reverse={i % 2 === 0}
                  occupancy={apt.occupancy}
                  bookingUrl={apt.bookingUrl}
                  bookingTarget={apt.bookingTarget}
                  figureMaxWidth={
                    apt.slug === 'signature-plus' ? 900 : 860
                  }
                />
              </Wrapper>
            </Section>
          ))}
        </Section>
      ))}
    </Layout>
  )
}

export const query = graphql`
  query ApartmentsPage {
    headerImage: file(name: { eq: "img-hero-apartment" }) {
      childImageSharp {
        fluid(maxWidth: 2560, quality: 100, cropFocus: CENTER) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default Suites
